// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__M3-v8","choiceBoxes":"toolbarselects_choiceBoxes__RjTja","simpleField":"toolbarselects_simpleField__1LMmG"};